// FT-066: native @rails/actioncable service (replaces the legacy name-keyed WS wrapper).
// Single consumer per tab; subscriptions are objects with handlers on them
// (no name-keyed registry → no collisions). urlFn is re-evaluated by the native
// consumer on every (re)connect → fresh token/region. SECURITY: never log the tokenized URL.
import { createConsumer as defaultCreateConsumer } from "@rails/actioncable";

let consumer = null;

// createConsumerImpl is injectable for tests (the only external dependency).
export function initCable(urlFn, createConsumerImpl = defaultCreateConsumer) {
  consumer = createConsumerImpl(urlFn);
  return consumer;
}

export function subscribe(params, handlers) {
  if (!consumer) {
    throw new Error("[cable] initCable() must be called before subscribe()");
  }
  return consumer.subscriptions.create(params, handlers);
}

export function reconnect() {
  if (!consumer) return;
  consumer.disconnect();
  consumer.connect();
}

export function disconnect() {
  if (!consumer) return;
  consumer.disconnect();
}

export function getConsumer() {
  return consumer;
}

// Test seam: reset module singleton between tests.
export function __resetForTests() {
  consumer = null;
}
